// import sImg1 from '../images/utilites/dontaion-details-thumb1.webp'
// import sImg2 from '../images/utilites/dontaion-details-thumb1.webp'
// import sImg3 from '../images/utilites/dontaion-details-thumb1.webp'
import Focused from '../images/about/focused.webp'
import CommunityPartnership from '../images/about/community-partnership.webp'
import Honesty from '../images/about/honesty.webp'
import EasyToJoin from '../images/about/easy-to-join.webp'
import EarnRewards from '../images/sewak-army/points.webp'
import TrustedNGOs from '../images/sewak-army/trusted-ngos.webp'
import Planning from '../images/sewak-army/planning.webp'
import Communication from '../images/sewak-army/communication.webp'
import Opportunities from '../images/sewak-army/problem-solving.webp'
import Join from '../images/life-saver-army/follow.webp'
import Community from '../images/life-saver-army/community.webp'
import Available from '../images/life-saver-army/available.webp'
import Challenge from '../images/life-saver-army/challenge.webp'
import Personalised from '../images/food-checker/personalized.webp'
import Allergy from '../images/food-checker/allergy.webp'
import Ingredient from '../images/food-checker/analysis.webp'
import Easy from '../images/about/easy-to-join.webp'
import Family from '../images/food-checker/social-support.webp'
import Stress from '../images/mind-unload/consulting.webp'
import Space from '../images/mind-unload/secure.webp'
import CommunityCare from '../images/mind-unload/solidarity.webp'
import Workshop from '../images/mind-unload/presentation.webp'
import Resources from '../images/mind-unload/teamwork.webp'
import Agile from '../images/akshay/agile.webp'
import Trusted from '../images/akshay/handshake.webp'
import Impact from '../images/akshay/trustworthiness.webp'
import Education from '../images/akshay/education.webp'
import Community1 from '../images/life-saver-army/community.webp'
import Technique from '../images/jains/knowledge-transfer.webp'
import Resource from '../images/jains/team.webp'
import Connection from '../images/jains/conference.webp'
import Leader from '../images/jains/community.webp'
import AmplifyVoice from '../images/reform-army/voice-recognition.webp'
import CommunityEngagement from '../images/reform-army/social-support.webp'
import TimeTracking from '../images/reform-army/automation.webp'
import Free from '../images/reform-army/free.webp'
import Plantation from '../images/volunteer-opportunities/holding-hand.webp'
import BloodDonation from '../images/volunteer-opportunities/blood-donation.webp'
import FloodRelief from '../images/volunteer-opportunities/flood.webp'
import SchoolActivity from '../images/volunteer-opportunities/student.webp'
import Transparent from '../images/donate/collective.webp'
import Causes from '../images/donate/funds.webp'
import Tax from '../images/donate/tax.webp'
import SchoolSupplies from '../images/donate/stationary.webp'
import PlantingTrees from '../images/donate/planting.webp'
import CheckUp from '../images/donate/checkup.webp'
import DonationDrive from '../images/donate/blood-donation.webp'
import FoodDelivery from '../images/donate/fast-delivery.webp'
import SevakArmy from '../images/donate/sevak-army.webp'
import LifeSeverArmy from '../images/home/lfe-saver-logo.webp'
import MyFoodChecker from '../images/home/MFC.webp'
import MindUnload from '../images/donate/MU.webp'
import AkshayNetra from '../images/home/akshay-netra.webp'
import ReformArmy from '../images/home/RA.webp'
import YoungJains from '../images/home/young-jain.webp'
import PledgeOrgans from '../images/home/PMO.webp'
import WideReach from '../images/about/wide-reach.webp'


const Services = [
    {
        Id: '0',
        // sImg: sImg1,
        icon: SevakArmy,
        alt: "Sevak Army Logo",
        title: 'Sevak Army',
        slug: 'together-Pledge',
        description: 'Connecting volunteers with NGOs to find tasks matching their time and skills to support social causes.',
    },
    {
        Id: '1',
        // sImg: sImg2,
        icon: LifeSeverArmy,
        alt: "Life Saver Army Logo",
        slug: 'Donate-for-HOmless',
        title: 'Life Saver Army',
        description: 'Bringing together donors and patients to deliver vital blood and platelets exactly when they’re needed.',
    },
    {
        Id: '2',
        // sImg: sImg3,
        icon: MyFoodChecker,
        alt: "My Food Checker Logo",
        title: 'My Food Checker',
        slug: 'Fundraise',
        description: 'Promoting food safety and healthy eating through scanning the food packages.',
    },
    {
        Id: '3',
        // sImg: sImg3,
        icon: MindUnload,
        alt: "Mind Unload Logo",
        title: 'Mind Unload',
        slug: 'Water-&-Healthy Food',
        description: 'Offering mental health support through mindfulness sessions and stress-relief activities.',
    },
    {
        Id: '4',
        // sImg: sImg3,
        icon: AkshayNetra,
        alt: "Akshay Netra Logo",
        title: 'Akshay Netra',
        slug: 'Study-&-Life-Tips',
        description: 'Restoring sight through eye donations and inspiring people to pledge, spreading awareness to end preventable blindness.',
    },
    {
        Id: '5',
        // sImg: sImg3,
        icon: YoungJains,
        alt: "Young Jains Logo",
        title: 'Young Jains',
        slug: 'Medical-&-Aid',
        description: 'Empowering youth with Jain values like compassion, mindfulness and non-violence.',
    },
    {
        Id: '6',
        // sImg: sImg3,
        icon: ReformArmy,
        alt: "Reform Army Logo",
        title: 'Reform Army',
        slug: 'Build-Home',
        description: 'A platform to start petitions and lead campaigns for social and environmental reform, shaping a fairer and more sustainable society.',
    },
    {
        Id: '7',
        // sImg: sImg3,
        icon: PledgeOrgans,
        alt: "Pledge My Organs Logo",
        title: 'Pledge My Organs',
        slug: 'Build-Home',
        description: 'Offers individuals the opportunity to pledge their organs for donation, streamlining the process and encouraging awareness about organ donation.',
    },
    {
        Id: '8',
        // sImg: sImg3,
        icon: Focused,
        title: 'Focused Projects',
        alt: "Growth and progress journey icon",
        slug: 'Build-Home',
        description: 'Our initiatives solve real-world problems and significantly improve lives in a meaningful way.',
    },
    {
        Id: '9',
        // sImg: sImg3,
        icon: CommunityPartnership,
        alt: "Community support and unity icon.",
        title: 'COMMUNITY COLLABORATIONS ',
        slug: 'Build-Home',
        description: 'We work closely with local communities to make sure our efforts meet their needs.',
    },
    {
        Id: '10',
        // sImg: sImg3,
        icon: Honesty,
        alt: "Partnership and handshake icon",
        title: 'Honesty and Transparency',
        slug: 'Build-Home',
        description: 'We act with integrity in everything we do, keeping all actions accountable.',
    },
    {
        Id: '11',
        // sImg: sImg3,
        icon: EasyToJoin,
        alt: "Team and collaboration icon.",
        title: 'Easy to Join',
        slug: 'Build-Home',
        description: 'We welcome everyone to get involved, whether by volunteering, donating or spreading the word.',
    },
    {
        Id: '12',
        // sImg: sImg3,
        icon: WideReach,
        title: 'Wide Reach',
        alt: "Global volunteer connections icon",
        slug: 'Build-Home',
        description: 'From health and education to preserving culture and protecting the environment, we take on diverse challenges.',
    },
    {
        Id: '13',
        // sImg: sImg3,
        icon: EarnRewards,
        alt: "Helping hand and support icon.",
        title: 'Earn Rewards',
        slug: 'Build-Home',
        description: 'Gain points, digital badges and digital certificates as you complete tasks and track your progress on the leaderboard.',
    },
    {
        Id: '14',
        // sImg: sImg3,
        icon: Planning,
        alt: "Task checklist and progress icon.",
        title: 'Wide Range of Tasks',
        slug: 'Build-Home',
        description: 'Volunteer in diverse fields, including education, healthcare, the environment and more.',
    },
    {
        Id: '15',
        // sImg: sImg3,
        icon: TrustedNGOs,
        alt: "NGO assistance and donation icon",
        title: 'Trusted NGOs',
        slug: 'Build-Home',
        description: 'Work with verified NGOs and know your efforts are making an impact.',
    },
    {
        Id: '16',
        // sImg: sImg3,
        icon: Communication,
        alt: "Two people communication icon",
        title: 'Direct Communication',
        slug: 'Build-Home',
        description: 'Chat directly with NGOs for better coordination and updates.',
    },
    {
        Id: '17',
        // sImg: sImg3,
        icon: Opportunities,
        alt: "Idea and action for life-saving initiatives icon",
        title: 'Personalised Opportunities',
        slug: 'Build-Home',
        description: 'Use filters to find tasks that match your skills, time and interests.',
    },
    {
        Id: '18',
        // sImg: sImg3,
        icon: Join,
        alt: "Medical volunteer providing support icon",
        title: 'Simple to Join',
        slug: 'Build-Home',
        description: 'Whether you want to donate blood, receive blood or volunteer, signing up is quick and easy.',
    },
    {
        Id: '19',
        // sImg: sImg3,
        icon: Community,
        alt: "Blood donation and life-saving symbol icon",
        title: 'Supportive Community',
        slug: 'Build-Home',
        description: 'Be part of a caring network where everyone works together to save lives.',
    },
    {
        Id: '20',
        // sImg: sImg3,
        icon: Available,
        alt: "24/7 emergency support icon",
        title: 'Always Available',
        slug: 'Build-Home',
        description: 'We ensure blood is accessible, including rare blood types, when it’s needed the most.',
    },
    {
        Id: '21',
        // sImg: sImg3,
        icon: Challenge,
        title: 'Every Effort Counts',
        alt: "Food quality inspection icon",
        slug: 'Build-Home',
        description: 'Every donation and every act of support makes a difference in someone’s life.',
    },

    {
        Id: '22',
        // sImg: sImg3,
        icon: Personalised,
        alt: "Hand offering user support icon.",
        title: 'Personalised Profiles',
        slug: 'Build-Home',
        description: 'Create dietary profiles for yourself and your family to manage everyone’s needs easily.',
    },
    {
        Id: '23',
        // sImg: sImg3,
        icon: Allergy,
        title: 'Instant Allergen Alerts',
        alt: "Food contamination check icon.",
        slug: 'Build-Home',
        description: 'Get notified about allergens or harmful ingredients with every scan.',
    },
    {
        Id: '24',
        // sImg: sImg3,
        icon: Ingredient,
        alt: "Food label and ingredient analysis icon",
        title: 'Clear Ingredient Information',
        slug: 'Build-Home',
        description: 'Understand food labels effortlessly and make confident decisions.',
    },
    {
        Id: '25',
        // sImg: sImg3,
        icon: Family,
        alt: "Family hand holding icon",
        title: 'Family-Friendly Features',
        slug: 'Build-Home',
        description: 'Manage multiple profiles and ensure safety for everyone in your household.',
    },
    {
        Id: '26',
        // sImg: sImg3,
        icon: Easy,
        title: 'Smart and Easy to Use',
        slug: 'Build-Home',
        description: 'Enjoy a simple, intuitive app that delivers everything you need at your fingertips.',
    },

    {
        Id: '27',
        // sImg: sImg3,
        icon: Stress,
        alt: "User rating and feedback icon.",
        title: 'Effortless Stress Relief',
        slug: 'Build-Home',
        description: 'Experience guided meditations, mindfulness exercises and creative outlets like art and journaling to restore balance and calm.',
    },
    {
        Id: '28',
        // sImg: sImg3,
        icon: Space,
        alt: "Mental wellness protection icon.",
        title: 'Safe Space for Expression',
        slug: 'Build-Home',
        description: 'Share your feelings openly in a judgment-free environment. Trained listeners and supportive sessions offer clarity and emotional relief.',
    },
    {
        Id: '29',
        // sImg: sImg3,
        icon: CommunityCare,
        alt: "Emotional care and support icon",
        title: 'Community of Care',
        slug: 'Build-Home',
        description: 'Connect with like-minded individuals through forums, support groups and mentorship programmes. Build strength with encouragement from those who understand.',
    },
    {
        Id: '30',
        // sImg: sImg3,
        icon: Workshop,
        alt: "Community mental health session icon",
        title: 'Expert-Led Workshops',
        slug: 'Build-Home',
        description: 'Participate in mindfulness retreats, stress management webinars and therapeutic art sessions, all led by mental health professionals.',
    },
    {
        Id: '31',
        // sImg: sImg3,
        icon: Resources,
        alt: "Judgement free icon",
        title: 'Vent Freely, No Judgment',
        slug: 'Build-Home',
        description: 'Express yourself freely in a safe, judgment-free space. Connect with a supportive listener or peer group - no account needed.',
    },

    {
        Id: '32',
        // sImg: sImg3,
        icon: Agile,
        alt: "Eye care process and checklist icon",
        title: 'Compassionate Process',
        slug: 'Build-Home',
        description: 'Eye donations are handled with utmost care and respect.',
    },
    {
        Id: '33',
        // sImg: sImg3,
        icon: Trusted,
        alt: "Partnership and donor support icon",
        title: 'Trusted Expertise',
        slug: 'Build-Home',
        description: 'Collaboration with renowned eye banks and hospitals.',
    },
    {
        Id: '34',
        // sImg: sImg3,
        icon: Impact,
        alt: "Eye examination and care icon",
        title: 'Life-Changing Impact ',
        slug: 'Build-Home',
        description: 'Encouraging pledges to provide hope.',
    },
    {
        Id: '35',
        // sImg: sImg3,
        icon: Education,
        alt: "Eye donation information book icon",
        title: 'Awareness and Education',
        slug: 'Build-Home',
        description: 'Campaigns and resources to inspire more pledges.',
    },
    {
        Id: '36',
        // sImg: sImg3,
        icon: Community1,
        alt: "Spiritual growth and mindfulness icon.",
        title: 'Community Engagement',
        slug: 'Build-Home',
        description: 'Building networks of donors, recipients, hospitals and volunteers.',
    },
    {
        Id: '37',
        // sImg: sImg3,
        icon: Technique,
        alt: "Idea sharing and knowledge icon",
        title: 'Valuable Teachings',
        slug: 'Build-Home',
        description: 'Practical tools to apply Jain principles like non-violence and mindfulness in daily life.',
    },
    {
        Id: '38',
        // sImg: sImg3,
        icon: Resource,
        alt: "Youth achievement and recognition icon",
        title: 'Inspiring Resources',
        slug: 'Build-Home',
        description: 'Access books, videos and workshops that simplify Jain teachings for today’s world.',
    },
    {
        Id: '39',
        // sImg: sImg3,
        icon: Connection,
        alt: "Youth leadership meeting icon",
        title: 'Building Leaders',
        slug: 'Build-Home',
        description: 'Mentorship programmes to nurture ethical and compassionate future leaders.',
    },
    {
        Id: '40',
        // sImg: sImg3,
        icon: Leader,
        alt: "Collaboration and teamwork icon.",
        title: 'Community Connection',
        slug: 'Build-Home',
        description: 'Opportunities to engage with like-minded individuals and foster lifelong relationships.',
    },

    {
        Id: '41',
        // sImg: sImg3,
        icon: AmplifyVoice,
        alt: "Public speaking and communication icon.",
        title: 'Amplify Your Voice',
        slug: 'Build-Home',
        description: 'Ensure your concerns are heard by those in power.',
    },
    // {
    //     Id: '42',
        // sImg: sImg3,
    //     icon: Templates,
    //     title: 'Pre-Filled Templates',
    //     slug: 'Build-Home',
    //     description: 'Simplify the process with ready-to-send emails.',
    // },
    {
        Id: '43',
        // sImg: sImg3,
        icon: CommunityEngagement,
        alt: "Analytics and performance review icon",
        title: 'Community Engagement',
        slug: 'Build-Home',
        description: 'Join others who are passionate about similar causes.',
    },
    {
        Id: '44',
        // sImg: sImg3,
        icon: TimeTracking,
        alt: "Process management and workflow icon",
        title: 'Real-Time Tracking',
        slug: 'Build-Home',
        description: 'See the progress and impact of your efforts.',
    },
    {
        Id: '45',
        // sImg: sImg3,
        icon: Free,
        title: 'Free and Inclusive',
        slug: 'Build-Home',
        description: 'Accessible to anyone who wants to make a difference.',
    },


    {
        Id: '46',
        // sImg: sImg3,
        icon: Plantation,
        alt: "Environmental care and growth icon",
        title: 'Tree Plantation Drive',
        slug: 'Build-Home',
        date: '12/03/2024',
        description: 'Join us in greening our community.',
    },
    {
        Id: '47',
        // sImg: sImg3,
        icon: BloodDonation,
        alt: "Hand holding water drop icon",
        title: 'Blood Donation Camp',
        slug: 'Build-Home',
        date: '12/03/2024',
        description: ' Help save lives through your donation.',
    },
    {
        Id: '48',
        // sImg: sImg3,
        icon: FloodRelief,
        alt: "Volunteer helping in flood relief icon",
        title: 'Flood Relief Packing',
        slug: 'Build-Home',
        date: '12/03/2024',
        description: 'Prepare essential supplies for affected areas.',
    },
    {
        Id: '49',
        // sImg: sImg3,
        icon: SchoolActivity,
        alt: "Volunteer idea and initiative icon.",
        title: 'School Activities',
        slug: 'Build-Home',
        date: '12/03/2024',
        description: 'Engage with children in creative and educational programmes.',
    },


    {
        Id: '50',
        // sImg: sImg3,
        icon: Transparent,
        alt: "Donation support and giving hands icon.",
        title: 'Transparent & Responsible Utilisation',
        slug: 'Build-Home',
        description: 'Every donation is carefully utilised to organise blood donation camps, conduct awareness initiatives and strengthen emergency blood support through Life Saver Army.',
    },
    {
        Id: '51',
        // sImg: sImg3,
        icon: Causes,
        alt: "Hand offering financial donation icon.",
        title: 'Supporting a Life-Saving Mission',
        slug: 'Build-Home',
        description: 'Your contribution helps us connect voluntary blood donors with patients, encourage regular blood donation and expand our network of lifesavers.',
    },
    {
        Id: '52',
        // sImg: sImg3,
        icon: Tax,
        alt: "Tax benefit and donation calculator icon",
        title: 'Tax Benefits',
        slug: 'Build-Home',
        description: 'Eligible donations made to Jainam Jivika Foundation qualify for tax benefits under Section 80G of the Income Tax Act.',
    },


    {
        Id: '53',
        // sImg: sImg3,
        icon: SchoolSupplies,
        alt: "Supplies donation box icon",
        title: '₹500',
        slug: 'Build-Home',
        description: 'Supports donor awareness materials and community outreach programmes.',
    },
    {
        Id: '54',
        // sImg: sImg3,
        icon: PlantingTrees,
        alt: "Hand nurturing plant for charitable growth icon",
        title: '₹1,000',
        slug: 'Build-Home',
        description: 'Helps register voluntary blood donors and expand our lifesaving network.',
    },
    {
        Id: '55',
        // sImg: sImg3,
        icon: CheckUp,
        alt: "Donation box with coins icon.",
        title: '₹2,000',
        slug: 'Build-Home',
        description: 'Supports the organisation of blood donation awareness and community engagement activities.',
    },
    {
        Id: '56',
        // sImg: sImg3,
        icon: DonationDrive,
        alt: "Supplies donation box icon",
        title: '₹5,000',
        slug: 'Build-Home',
        description: 'Contributes towards organising a voluntary blood donation camp with essential resources.',
    },
    {
        Id: '57',
        // sImg: sImg3,
        icon: FoodDelivery,
        alt: "Delivery of donated goods icon.",
        title: '₹10,000',
        slug: 'Build-Home',
        description: 'Strengthens emergency blood support initiatives and helps us reach more patients in need.',
    },
]

export default Services;